import { BUTTON_SIZES, GhostSuccessButton } from 'ui/button';
import { Add16 } from 'ui/icons';

type Props = {
  onClick: () => void;
};

export const NewMessageTypeButton = ({ onClick }: Props) => {
  return (
    <>
      <GhostSuccessButton
        data-test="add-message-type-btn"
        onClick={onClick}
        size={BUTTON_SIZES.LARGE}
      >
        <Add16 />
        <span>Add message type</span>
      </GhostSuccessButton>
    </>
  );
};
